import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { IONA, waLink } from "@/constants/site";

export default function WhatsAppFloat() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={`tel:${IONA.phoneIntl}`}
        data-testid="float-call-btn"
        aria-label="Hemen Ara"
        className="group flex items-center gap-3 bg-white text-[#5E2A84] pl-4 pr-5 py-3 rounded-full shadow-[0_8px_24px_rgba(94,42,132,0.18)] hover:shadow-[0_10px_30px_rgba(94,42,132,0.28)] transition-all border border-[#F4F1F9]"
      >
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline text-sm font-medium whitespace-nowrap">
          Hemen Ara
        </span>
      </a>

      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float"
        aria-label="WhatsApp'tan Yaz"
        className="group"
      >
        <div className="relative whatsapp-pulse">
          <div className="flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-all duration-300">
            <MessageCircle className="w-5 h-5" />
            <span className="hidden sm:inline text-sm font-medium whitespace-nowrap">
              WhatsApp'tan Yaz
            </span>
          </div>
        </div>
      </a>
    </div>
  );
}
